import React from 'react';
import { connect } from 'react-redux';

import { SelectField, Label, BoxDouble } from 'jbc-front/components/Form';
import { getSelectOptions } from 'src/reducers/selectOptions';
import selector from 'src/utils/Utils';
import { getEmploymentInsuranceFormValues } from 'src/reducers/clients/insurance';

const filterHelloWork = (helloWorks, prefectureId) => helloWorks[prefectureId] || [];

const HelloWork = ({ helloWorks, selectedPrefectureId, prefectures }) => (
  <div>
    <Label text="管轄のハローワーク" />
    <BoxDouble>
      <SelectField name="helloWorkPrefectureId" options={prefectures} />
      <SelectField name="helloWorkId" options={filterHelloWork(helloWorks, selectedPrefectureId)} />
    </BoxDouble>
  </div>
);

export default connect(state => ({
  prefectures: getSelectOptions(state, 'prefectures'),
  selectedPrefectureId: parseInt(selector(getEmploymentInsuranceFormValues(state), 'helloWorkPrefectureId'), 10),
  helloWorks: getSelectOptions(state, 'helloWorks')
}))(HelloWork);
